import { Component} from '@angular/core';


// 1. Interface for Fun Facts
export interface FactItem {
  value: string;
  label: string;
  delay: string;
}

// 2. Interface for Service Items
export interface ServiceItem {
  icon: string;
  title: string;
  description: string;
  link: string;
  delay: string;
}


@Component({
  standalone: false,
  selector: 'app-services',
  templateUrl: './services.component.html',
  styleUrl: './services.component.css'
})
export class ServicesComponent {
  // Fun Facts Data Array
  facts: FactItem[] = [
    {
      value: '99',
      label: 'Success in getting happy customer',
      delay: '.1s'
    },
    {
      value: '25',
      label: 'Thousands of successful business',
      delay: '.3s'
    },
    {
      value: '120',
      label: 'Total clients who love HighTech',
      delay: '.5s'
    },
    {
      value: '5',
      label: 'Stars reviews given by satisfied clients',
      delay: '.7s'
    }
  ];

  // Lifecycle Hooks
  ngOnInit(): void {
    // Initialization code (if any)
  }

  ngOnDestroy(): void {
    // Cleanup code (if any)
  }

  // Services Data Array
  services: ServiceItem[] = [
    {
      icon: 'bi bi-boxes',
      title: 'Web Design',
      description: 'Lorem ipsum dolor sit amet elit. Sed efficitur quis purus ut interdum. Aliquam dolor eget urna ultricies tincidunt.',
      link: '/services',
      delay: '.3s'
    },
    {
      icon: 'bi bi-brilliance',
      title: 'Web Development',
      description: 'Lorem ipsum dolor sit amet elit. Sed efficitur quis purus ut interdum. Aliquam dolor eget urna ultricies tincidunt.',
      link: '/services',
      delay: '.5s'
    },
    {
      icon: 'bi bi-brush-fill',
      title: 'UI/UX Design',
      description: 'Lorem ipsum dolor sit amet elit. Sed efficitur quis purus ut interdum. Aliquam dolor eget urna ultricies tincidunt.',
      link: '/services',
      delay: '.7s'
    },
    {
      icon: 'bi bi-bullseye',
      title: '3d Animation',
      description: 'Lorem ipsum dolor sit amet elit. Sed efficitur quis purus ut interdum. Aliquam dolor eget urna ultricies tincidunt.',
      link: '/services',
      delay: '.3s'
    },
    {
      icon: 'bi bi-circle-square',
      title: 'Digital Marketing',
      description: 'Lorem ipsum dolor sit amet elit. Sed efficitur quis purus ut interdum. Aliquam dolor eget urna ultricies tincidunt.',
      link: '/services',
      delay: '.5s'
    },
    {
      icon: 'bi bi-code-slash',
      title: 'Programming',
      description: 'Lorem ipsum dolor sit amet elit. Sed efficitur quis purus ut interdum. Aliquam dolor eget urna ultricies tincidunt.',
      link: '/services',
      delay: '.7s'
    }
  ];
}
